<template>
  <div class="routes-list-item"
       :class="modifiers"
       :tabindex="isInteractive ? 0 : -1"
       @click="activeRoute"
  >
    <route-marker :route="route"
                  class="routes-list-item__route-marker"
    />

    <div class="routes-list-item__content">
      <p class="routes-list-item__title">
        {{ name }}
      </p>

      <div class="routes-list-item__description"
           v-if="route.description"
      >
        <span>{{ route.description }}</span>
      </div>

      <!-- <div class="routes-list-item__period">
        {{ periodLabel }}
      </div> -->
    </div>
  </div>
</template>

<script>
import Route from "@/models/Route";
import RouteMarker from "@/components/common/RouteMarker/RouteMarker.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "RoutesListItem",
  components: {
    RouteMarker
  },
  props: {
    route: {
      type: Route,
      required: true
    },
    isInteractive: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState('Routes', ['activeRouteId']),
    ...mapState('Filters', ['beforeYear']),

    coordinates() {
      return this.route.coordinates
    },
    fromYear() {
      return this.route.fromYear
    },
    toYear() {
      return this.route.toYear
    },
    periodLabel() {
      return [
        this.fromYear,
        this.toYear
      ]
        .filter((year) => year !== Infinity && year !== -Infinity)
        .join(' - ')
    },
    name() {
      return this.route.label
    },
    isActive() {
      return this.route.id === this.activeRouteId
    },
    isDisabled() {
      return !!this.beforeYear && this.toYear > this.beforeYear
    },
    modifiers() {
      return {
        'routes-list-item--is-interactive': this.isInteractive,
        'routes-list-item--is-active': this.isActive && this.isInteractive,
        'routes-list-item--is-disabled': this.isDisabled
      }
    }
  },
  methods: {
    activeRoute() {
      if (!this.isInteractive) return false;

      this.setActiveRouteId(this.route.id)
    },

    ...mapActions('Routes', ['setActiveRouteId'])
  }
}
</script>

<style lang="scss">
.routes-list-item {
  padding: 15px 17px;
  display: grid;
  grid-template-columns: auto 1fr;
  grid-column-gap: 12px;
  align-items: center;
  transition: background-color .3s;
  background-color: rgba($app-primary-color, 0);
  height: fit-content;

  .routes-list-item__content{
    overflow-y: auto;
  }

  &--is-interactive {
    cursor: pointer;
  }

  &:hover#{&}--is-interactive,
  &--is-active#{&}--is-interactive {
    background-color: rgba($app-primary-color, 0.15);
  }

  &--is-disabled {
    opacity: .5;
    cursor: default;
    pointer-events: none;
  }

  &__route-marker {
    margin-bottom: auto;
  }

  &__content {
    display: flex;
    flex-direction: column;
    grid-row-gap: 5px;
  }

  &__title {
    color: $input-title-color;
    font-size: 24px;
    font-weight: 700;
    transition: color .3s;
  }
  &--is-active &__title {
    color: $app-primary-color;
  }

  &__description {
    position: relative;
    font-size: 16px;
    font-weight: 400;
    height: 1em;

    span {
      position: absolute;
      left: 0;
      top: 0;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 100%;
    }
  }

  &__period {
    font-weight: 500;
  }

}
</style>